module.exports = __webpack_public_path__ + "img/zm_ljdt@3x.27fab273.png";